import { Box, Chip, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";

import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { formatDate } from "@/shared/utils/formatDate";
import { CombinedNode } from "@/shared/utils/nodes";
import { PreDefinedConstraints } from "../../../types";
import { ChatAvatar } from "../primitives/ChatAvatar";
import { MessageBubble } from "../primitives/MessageBubble";

interface UserMessageProps {
  content: string;
  preSetConstraints?: PreDefinedConstraints;
}

const UserMessageComponent: React.FC<UserMessageProps> = ({ content, preSetConstraints }) => {
  const { nodes } = useInfo();
  let matchingNode: CombinedNode | undefined = undefined;
  let matchinglayer: string | undefined = undefined;
  const hasConstraints =
    preSetConstraints &&
    (preSetConstraints.brand ||
      preSetConstraints.category ||
      preSetConstraints.product ||
      preSetConstraints.startDate ||
      preSetConstraints.endDate);
  if (hasConstraints) {
    matchingNode = nodes?.findNodeByBrandCategoryProduct(
      preSetConstraints.brand || "",
      preSetConstraints.category || "",
      preSetConstraints.product || ""
    );
    matchinglayer = matchingNode?.warchestNode.name;
  }
  return (
    <Box>
      <MessageBubble variant="user" avatar={<ChatAvatar variant="user" />}>
        <Typography variant="body1" sx={{ lineHeight: 1.5 }}>
          {content}
        </Typography>
      </MessageBubble>
      {hasConstraints && (
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            flexWrap: "wrap",
            gap: 0.5,
            mt: 1,
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {matchingNode && (
            <Chip
              label={`Business Unit: ${matchinglayer}`}
              size="small"
              sx={{
                height: "20px",
                fontSize: "11px",
                backgroundColor: (theme) => theme.palette.grey[200],
                "& .MuiChip-label": {
                  px: 1,
                },
              }}
            />
          )}
          {preSetConstraints.startDate && preSetConstraints.endDate && (
            <Chip
              label={`Date Range: ${formatDate(dayjs(preSetConstraints.startDate))} - ${formatDate(dayjs(preSetConstraints.endDate))}`}
              size="small"
              sx={{
                height: "20px",
                fontSize: "11px",
                backgroundColor: (theme) => theme.palette.grey[200],
                "& .MuiChip-label": {
                  px: 1,
                },
              }}
            />
          )}
        </Stack>
      )}
    </Box>
  );
};

export const UserMessage = React.memo(UserMessageComponent);
